import { render, staticRenderFns } from "./email_details.vue?vue&type=template&id=137ddf3e&scoped=true&"
import script from "./email_details.vue?vue&type=script&lang=js&"
export * from "./email_details.vue?vue&type=script&lang=js&"
import style0 from "./email_details.vue?vue&type=style&index=0&id=137ddf3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ddf3e",
  null
  
)

export default component.exports